import $http from '@/libs/axios'

export default class ReplyApi {
  static async deleteReplyTemplate(id: string) {
    return (await $http.delete(`facebook/reply/templates/${id}`)).data
  }

  static async find(postId: any) {
    return (await $http.get(`facebook/reply/get/${postId}`)).data
  }

  static async deleteReply(id: string) {
    return (await $http.delete(`facebook/reply/delete/${id}`)).data
  }

  static async changeReplyStatus(id: string) {
    return (await $http.get(`facebook/reply/change-status/${id}`)).data
  }

  static async templatesList() {
    return (await $http.get('facebook/reply/templates')).data
  }

  /** Page owners’ reply templates for a given Facebook page (admin n8n, etc.). */
  static async templatesListForPage(pageId: number) {
    return (await $http.get('facebook/reply/templates', {
      headers: { 'page-id': pageId },
    })).data
  }

  static async addReply(data: any) {
    return (await $http.post('facebook/reply/add', data, { headers: { 'Content-Type': 'multipart/form-data' } })).data
  }

  static async dependencies() {
    return (await $http.get('facebook/reply/dependencies')).data
  }

  static async findTemplate(id: any) {
    return (await $http.get(`facebook/reply/templates/${id}`)).data
  }

  static async addTemplate(data: any) {
    return (await $http.post('facebook/reply/templates', data, { headers: { 'Content-Type': 'multipart/form-data' } })).data
  }

  static async leaveComment(data: any) {
    return (await $http.post('facebook/reply/comment', data)).data
  }

  static async togglePageCommenter(id: any) {
    return (await $http.get(`facebook/reply/page-commenter/${id}`)).data
  }

  static async replyOldComments(replyId: number | string, limit: number) {
    return (await $http.post(`admin/fb/replies/${replyId}/reply-old-comments`, { limit })).data
  }
}
